import ClaimCard from "./ClaimCard";
import ShopVisitCRU from "./ShopVisitCru";
import ShopVisitCard from "./ShopVisitCard";
import ShopVisitList from "./ShopVisitList";
import LLP from "./LLP";
import WorkScopeTable from "./Workscope";

export {ClaimCard, ShopVisitCRU, ShopVisitCard, ShopVisitList,LLP,WorkScopeTable}

export const approvalStatus = [{label : "Approve",value :1},{label : "Reject",value :2}]